import RailsResource from "./rails-resource";

export default new class extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'batch_schedules',
      ajaxLoader: true
    });
  }

  edit(batchId, batchScheduleId, params) {
    return this.patch(`${this.url}/batches/${batchId}/${this.resource}/${batchScheduleId}.json`, true, {
      batch_schedule: {
        start_time: params['start_time'],
        end_time: params['end_time'],
      }
    });
  }

  move(batchId, batchScheduleId, weekDay) {
    return this.patch(`${this.url}/batches/${batchId}/${this.resource}/${batchScheduleId}.json`, true, {
      batch_schedule: { week_day: weekDay }
    });
  }

  activate(batchId, batchScheduleId) {
    return this.put(`${this.url}/batches/${batchId}/${this.resource}/${batchScheduleId}/activate.json`, true);
  }
}